/**
 * AmbassadorHost — monta os overlays do programa de recomendação (convite de adesão e
 * compartilhamento de conteúdo) como diálogos globais no AppShell, sobre a tela atual.
 */
import { useAmbassadorStore } from './ambassadorStore';
import { OptInDialog } from './OptInDialog';
import { ShareDialog } from './ShareDialog';

export function AmbassadorHost(): JSX.Element {
  const optInOpen = useAmbassadorStore((s) => s.optInOpen);
  const optInReason = useAmbassadorStore((s) => s.optInReason);
  const closeOptIn = useAmbassadorStore((s) => s.closeOptIn);

  return (
    <>
      {optInOpen ? <OptInDialog onClose={closeOptIn} reason={optInReason} /> : null}
      <ShareDialog />
    </>
  );
}
